import React, { Component } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import './Navigation.css';

class Mainproject extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: 'KingSRK CarDOC',
    };
  }

  render() {
    return (
      <div className="main-container">
        <div className="cartop">
          <Navbar bg="dark" variant="dark" className="unique-navbar-bg">
            <Nav className="nav-links">
              <Link to="/Mainproject" className="nav-link">Home</Link>
              <Link to="/Service" className="nav-link">Services</Link>
              <Link to="/Shop" className="nav-link">Shop</Link>
              <Link to="/About" className="nav-link">About</Link>
              <Link to="/Contact" className="nav-link">Contact</Link>
            </Nav>
          </Navbar>
        </div>
        <div className="navigation-bg">
          <Card className="bg-dark text-white border-0">
            <Card.Img
              src="https://images.pexels.com/photos/164634/pexels-photo-164634.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              className="card-img"
              alt="Background"
              height="550px"
            />
            <Card.ImgOverlay className="overlay-content">
              <Card.Title className="fade-in">Welcome to KingSRK CarDOC</Card.Title>
              <Card.Text className="fade-in">Your ultimate destination for car services</Card.Text>
            </Card.ImgOverlay>
          </Card>
        </div>
      </div>
    );
  }
}

export default Mainproject;
